import { render } from "./ViewRateCard.vue?vue&type=template&id=4751319c&scoped=true"
import script from "./ViewRateCard.vue?vue&type=script&lang=js"
export * from "./ViewRateCard.vue?vue&type=script&lang=js"

import "./ViewRateCard.vue?vue&type=style&index=0&id=4751319c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4751319c"]])

export default __exports__